import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'src/state/types';

import { CartQuantities, CartState } from './types';

export const selectIsCartPopulated = (state: RootState): boolean => {
  const cart = selectItemFromCart(state);

  return cart.purchase > 0 || cart.upgrade.length > 0;
};

export const selectItemFromCart = (state: RootState): CartState => state.cart;

export const selectIsCartOpen = (state: RootState): boolean => state.cart.isCartOpen;

const selectUpgradeFromCart = createSelector(selectItemFromCart, (cart) => cart.upgrade);

const selectPurchaseFromCart = createSelector(selectItemFromCart, (cart) => cart.purchase);

export const selectItemQuantitiesFromCart = createSelector(
  [selectUpgradeFromCart, selectPurchaseFromCart],
  (upgrade, purchase): CartQuantities => ({
    quantityTotal: upgrade.length + purchase,
    quantityPurchase: purchase,
    quantityUpgrade: upgrade.length,
  }),
);
